import { InteractionType } from "@azure/msal-browser";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { useState } from "react";
import { Button } from "@mui/material";

export default function LoginButton() {
  const [authenticate, setAuthenticate] = useState(false);

  function redirectAuth() {
    setAuthenticate(true);
  }

  return (
    <>
      {authenticate && (
        <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
          You are already authenticated
        </MsalAuthenticationTemplate>
      )}
      <Button variant="contained" onClick={() => redirectAuth()}>Sign in</Button>
    </>
  );
}
